"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = __importDefault(require("../../"));
/**
 * The <b>Recommendation API</b> returns information that sellers can use to optimize the configuration of their
 * listings on eBay.
 */
class Recommendation extends __1.default {
    get basePath() {
        return '/sell/recommendation/v1';
    }
    /**
     * The find method returns recommendations and information that sellers can use to optimize their listing
     * configurations.
     *
     * @param filter Provide a list of key-value pairs to specify the criteria you want to use to filter the response.
     * @param limit Use this query parameter to set the maximum number of ads to return on a page from the paginated
     *     response. Default: 10 Maximum: 500
     * @param offset Specifies the number of ads to skip in the result set before returning the first ad in the
     *     paginated response.
     * @param body FindListingRecommendationRequest
     */
    findListingRecommendations({ filter, limit, offset } = {}, body) {
        return this.post(`/find`, {
            data: body,
            params: {
                filter,
                limit,
                offset
            }
        });
    }
}
exports.default = Recommendation;
Recommendation.id = 'Recommendation';
//# sourceMappingURL=index.js.map